import React, { useState, useEffect } from 'react';
import UTM from 'utm-latlng';

import { API_URL } from '../../config';
import { authFetch } from '../../utils';

export default function LocationForm({ location, onSave, onCancel }) {
  const [name, setName] = useState(location?.name || '');
  const [longName, setLongName] = useState(location?.longName || '');
  const [utmx, setUtmx] = useState(location?.utmx || '');
  const [utmy, setUtmy] = useState(location?.utmy || '');
  const [successMessage, setSuccessMessage] = useState('');
  

  const utm = new UTM();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!location) {
      // Check if location with same name already exists
      const checkRes = await authFetch(`${API_URL}locations/${encodeURIComponent(name)}`);
      if (checkRes.status === 200) {
        const existing = await checkRes.json();
        if (existing && existing._id) {
          alert('Ya existe una ubicación con ese nombre.');
          return;
        }
      }
    }

    const geoCoordinates = utm.convertUtmToLatLng(utmx, utmy, 30, 'S');

    const method = location ? 'PUT' : 'POST';
    const url = location ? `${API_URL}locations/${location.name}` : `${API_URL}location`;
    const res = await authFetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, longName, latitude: parseFloat(geoCoordinates.lat).toFixed(6), longitude: parseFloat(geoCoordinates.lng).toFixed(6) })
    });

    if (res.status !== 200 && res.status !== 201) {
      alert('Error al guardar la ubicación. Status: ' + res.status);
      return;
    }
    setSuccessMessage('Ubicación guardada con éxito');
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
    onSave(location);
  };

    useEffect(() => {
    if (location) {
      setName(location.name || '');
      setLongName(location.longName || '');

      // Si utmx/utmy no están en la ubicación, los calculamos desde lat/lon
      if (location.utmx && location.utmy) {
        setUtmx(location.utmx);
        setUtmy(location.utmy);
      } else if (location.latitude && location.longitude) {
        const utm = new UTM();
        const utmCoords = utm.convertLatLngToUtm(location.latitude, location.longitude , 0);
        setUtmx(utmCoords.Easting);
        setUtmy(utmCoords.Northing);
      }
    }
  }, [location]);

const inputStyle = {
  width: '100%',
  padding: '0.75rem',
  fontSize: '1rem',
  borderRadius: '6px',
  border: '1px solid #ccc',
  backgroundColor: '#fff'
};

const buttonPrimary = {
  padding: '0.5rem 1.25rem',
  backgroundColor: '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer'
};

const buttonSecondary = {
  padding: '0.5rem 1.25rem',
  backgroundColor: '#6c757d',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer'
};



  return (
    <>
      <form
  onSubmit={handleSubmit}
  style={{
    maxWidth: '600px',
    margin: '2rem auto',
    padding: '2rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
  }}
>
  <h3 style={{ textAlign: 'center', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
    {location ? '✏️ Editar Ubicación' : '➕ Crear Ubicación'}
  </h3>

  <div style={{ marginBottom: '1rem' }}>
    <label style={{ display: 'block', marginBottom: '0.5rem' }}>Nombre</label>
    <input
      value={name}
      onChange={e => setName(e.target.value)}
      placeholder="Nombre"
      required
      style={inputStyle}
    />
  </div>

  <div style={{ marginBottom: '1rem' }}>
    <label style={{ display: 'block', marginBottom: '0.5rem' }}>Nombre Largo</label>
    <input
      value={longName}
      onChange={e => setLongName(e.target.value)}
      placeholder="Nombre Largo"
      required
      style={inputStyle}
    />
  </div>

  <div style={{ marginBottom: '1rem' }}>
    <label style={{ display: 'block', marginBottom: '0.5rem' }}>UTM X</label>
    <input
      value={utmx}
      onChange={e => setUtmx(e.target.value)}
      placeholder="UTM X"
      required
      style={inputStyle}
    />
  </div>

  <div style={{ marginBottom: '1.5rem' }}>
    <label style={{ display: 'block', marginBottom: '0.5rem' }}>UTM Y</label>
    <input
      value={utmy}
      onChange={e => setUtmy(e.target.value)}
      placeholder="UTM Y"
      required
      style={inputStyle}
    />
  </div>

  <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
    <button type="submit" style={buttonPrimary}>Guardar</button>
    <button type="button" onClick={onCancel} style={buttonSecondary}>Cancelar</button>
  </div>
</form>

{successMessage && (
  <div style={{
    backgroundColor: '#d4edda',
    color: '#155724',
    padding: '0.75rem',
    borderRadius: '6px',
    border: '1px solid #c3e6cb',
    margin: '1rem auto',
    maxWidth: '600px',
    textAlign: 'center'
  }}>
    {successMessage}
  </div>
)}

    </>
  );
}
